import React, { useEffect, useRef, useState } from "react";
import "../TopHeader/TopHeader.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderLogo from "../../assets/images/logo/header-logo.svg";
import NotificationIcon from "../../assets/images/vactor/notification-ball.svg";
import LoginProfile from "../../assets/images/vactor/default-image.svg";
import FillDownArrow from "../../assets/images/vactor/fill-down-arrow.svg";
import EmptyNotification from "../../assets/images/vactor/Empty-notification.svg";
import { Button, Menu, MenuItem } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { logout } from "../../Slice/userSlice";
import EditProfile from "../AdminComponents/EditProfile/EditProfile";
import SignOutDialog from "../AdminComponents/SignOutDialog/SignOutDialog";
import { getUserDetails } from "../../Services/profile.service";
import { logoutAPI } from "../../Services/auth.service";
import { appendCacheBuster } from "../../Utils/url";
interface HeaderProps {
  onMenuToggle: () => void;
}
interface HeaderProps {
  onHistoryToggle: () => void;
}
const TopHeader: React.FC<HeaderProps> = ({ onMenuToggle, onHistoryToggle }) => {
  const navigate = useNavigate();
 const id = localStorage.getItem("id");
 useEffect(() => {
   if (id) {
     dispatch(getUserDetails(id))
        .unwrap();
    }
 }, []);
  const user = useAppSelector(state => state.user.user);
  const course = useAppSelector(state => state.course.course);
  const intermediateCourse = useAppSelector(state => state.course.intermediateCourse);
  const advancedCourse = useAppSelector(state => state.course.advancedCourse);
  const beginnerNotificationShown = useRef(false);
  const intermediateNotificationShown = useRef(false);
  const advancedNotificationShown = useRef(false);
  const [notification, setNotification] = useState<any>();
  const [intermediateNotification, setIntermediateNotification] = useState<any>();
  const [advancedNotification, setAdvancedNotification] = useState<any>();
  const [isBeginnerRead, setIsBeginnerRead] = useState(false);
  const [isIntermediateRead, setIsIntermediateRead] = useState(false);
  const [isAdvancedRead, setIsAdvancedRead] = useState(false);

  const handleMarkAllAsRead = () => {
    setIsBeginnerRead(true);
    setIsIntermediateRead(true);
    setIsAdvancedRead(true);
    handleCloseNotify(); // Close the dropdown after marking as read
  };

  // Beginner course notification
  useEffect(() => {
    if (course && user.is_paid === true && user.test_given === true && !beginnerNotificationShown.current) {
      setNotification("Beginner level course has been generated!");
      beginnerNotificationShown.current = true;
      // setTimeout(() => {
      //   const notifyButton = document.getElementById('notify-menu');
      //   if (notifyButton) {
      //     setNotify(notifyButton as HTMLButtonElement);

      //     // Optional: Auto-close after 5 seconds
      //     setTimeout(() => {
      //       setNotify(null);
      //     }, 7000);
      //   }
      // }, 100);
    }
  }, [course, user])

  // Intermediate course notification
  useEffect(() => {
    if (intermediateCourse && user.is_paid === true && user.test_given === true && !intermediateNotificationShown.current) {
      setIntermediateNotification("Intermediate level course has been generated!");
      intermediateNotificationShown.current = true;
      // setTimeout(() => {
      //   const notifyButton = document.getElementById('notify-menu');
      //   if (notifyButton) {
      //     setNotify(notifyButton as HTMLButtonElement);

      //     // Optional: Auto-close after 5 seconds
      //     setTimeout(() => {
      //       setNotify(null);
      //     }, 7000);
      //   }
      // }, 100);
    }
  }, [intermediateCourse, user])

  // Advanced course notification
  useEffect(() => {
    if (advancedCourse && user.is_paid === true && user.test_given === true && !advancedNotificationShown.current) {
      setAdvancedNotification("Advanced level course has been generated!");
      advancedNotificationShown.current = true;
      // setTimeout(() => {
      //   const notifyButton = document.getElementById('notify-menu');
      //   if (notifyButton) {
      //     setNotify(notifyButton as HTMLButtonElement);

      //     // Optional: Auto-close after 7 seconds
      //     setTimeout(() => {
      //       setNotify(null);
      //     }, 7000);
      //   }
      // }, 100);
    }
  }, [advancedCourse, user])

  const [notify, setNotify] = React.useState<null | HTMLElement>(null);
  const openNotify = Boolean(notify);
  // const [UserImage, setUserImage] = useState<string>(
  //   user.profile_image
  //     ? `http://103.204.189.95:5003${user.profile_image}`
  //     : LoginProfile
  // );
  const [UserImage, setUserImage] = useState<string>(LoginProfile);
  // useEffect(() => {
  //   if (user && user.profile_image) {
  //     setUserImage(`http://103.204.189.95:5003${user.profile_image}`)
  //   } else if (user) {
  //     setUserImage(LoginProfile)
  //   }
  // }, [user])
  useEffect(() => {
    if (user && user.profile_image) {
      setUserImage(appendCacheBuster(user.profile_image, Date.now()));
    } else if (user) {
      setUserImage(LoginProfile);
    }
  }, [user, user?.profile_image]);

  const refreshUserImage = () => {
    if (user && user.profile_image) {
      const timestamp = Date.now();
      const newImageUrl = appendCacheBuster(user.profile_image, timestamp);
      setUserImage(newImageUrl);

      // Force a re-render by setting a slightly different URL
      setTimeout(() => {
        setUserImage(appendCacheBuster(user.profile_image, timestamp + 1));
      }, 100);
    }
  };

  // Call this function after successful profile update
  // You can call refreshUserImage() in a useEffect that watches for user changes:
  useEffect(() => {
    refreshUserImage();
  }, [user?.profile_image]);

  const handleClickNotify = (event: React.MouseEvent<HTMLButtonElement>) => {
    setNotify(event.currentTarget);
  };
  const handleCloseNotify = () => {
    setNotify(null);
  };

  const [menu, setMenu] = React.useState<null | HTMLElement>(null);
  const open = Boolean(menu);
  const dispatch = useAppDispatch();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenu(event.currentTarget);
  };
  const handleClose = () => {
    setMenu(null);
  };

  const [profile, setProfile] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(profile);
  const handleClickProfile = (event: React.MouseEvent<HTMLButtonElement>) => {
    setProfile(event.currentTarget);
  };
  const handleCloseProfile = () => {
    setProfile(null);
  };
  const handleSignOut = async () => {
    await dispatch(logoutAPI());
    await localStorage.clear();
    await navigate("/login");
    await dispatch(logout());
  }

  // Admin view profile popup 
  const [viewprofile, setViewprofile] = React.useState(false);

  const handleClickOpen = () => {
    setViewprofile(true);
  };

  const handleClosePopup = () => {
    setViewprofile(false);
  };
  // Admin sign out popup
  const [signout, setSignout] = React.useState(false);
  const location = useLocation();
  const handleClickSignout = () => {
    setSignout(true);
  };

  const handleCloseSignout = () => {
    setSignout(false);
  };

  const hasActiveNotifications =
    (notification) ||
    (intermediateNotification) ||
    (advancedNotification);

  return (
    <>
      <header className="top-header-section sticky-top">
        <nav className="navbar navbar-expand-lg navbar-light ">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/dashboard">
              <img src={HeaderLogo} alt="HeaderLogo" />
            </Link>
            <div className="top-right-menu">
              {!location.pathname.startsWith('/admin') && <Button
                className="notification-badge"
                id="notify-menu"
                aria-controls={openNotify ? "notify-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openNotify ? "true" : undefined}
                onClick={handleClickNotify}
              >
                {((notification && !isBeginnerRead) ||
                  (intermediateNotification && !isIntermediateRead) ||
                  (advancedNotification && !isAdvancedRead)) && <div className="status-badge"></div>
                }
                <img src={NotificationIcon} alt="NotificationIcon" />
              </Button>}
              {!location.pathname.startsWith('/admin') && <Menu
                className=" notify-dropdown"
                id="notify-menu"
                anchorEl={notify}
                open={openNotify}
                onClose={handleCloseNotify}
                MenuListProps={{
                  "aria-labelledby": "notify-menu",
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <div className="notify-head">
                  <h4 className="notify-head-title">Notifications</h4>
                  <Link
                    className={`mark-read ${(!hasActiveNotifications || (isBeginnerRead && isIntermediateRead && isAdvancedRead)) ? "disabled":""}`}
                    to=""
                    onClick={(e) => {
                      e.preventDefault();
                      handleMarkAllAsRead();
                    }}
                  >
                    Mark all as read
                  </Link>
                </div>
                {/* Beginner notification */}
                {notification && (
                  <MenuItem
                    className={`notify-items ${!isBeginnerRead ? "recent-item": ""}`}
                    onClick={() => {
                      navigate('/dashboard/course_list');
                      handleCloseNotify();
                      setIsBeginnerRead(true);
                    }}
                  >
                    <p className="notify-items-text">
                      {notification}
                    </p>
                  </MenuItem>
                )}

                {/* Intermediate notification */}
                {intermediateNotification && (
                  <MenuItem
                    className={`notify-items ${!isIntermediateRead ? "recent-item":""}`}
                    onClick={() => { 
                      navigate('/dashboard/course_list'); 
                      handleCloseNotify();
                      setIsIntermediateRead(true);
                     }}
                  >
                    <p className="notify-items-text">
                      {intermediateNotification}
                    </p>
                  </MenuItem>
                )}

                {/* Advanced notification */}
                {advancedNotification && (
                  <MenuItem
                    className={`notify-items ${!isAdvancedRead ? "recent-item":""}`}
                    onClick={() => {
                      navigate('/dashboard/course_list');
                      handleCloseNotify();
                      setIsAdvancedRead(true);
                    }}
                  >
                    <p className="notify-items-text">
                      {advancedNotification}
                    </p>
                  </MenuItem>
                )}

                <MenuItem className="notify-items" onClick={handleCloseNotify} style={{ display: "none" }}>
                  <p className="notify-items-text">
                    Your new leaning exercise was ready to start.
                  </p>
                  <p className="notify-items-time">2 min ago</p>
                </MenuItem>
                {!hasActiveNotifications && (
                  <div className="empty-notification-block">
                    <img src={EmptyNotification} alt="" />
                    <p className="empty-notification-dsc">
                      There are no records of courses yet. Please check back later.
                    </p>
                  </div>
                )}
                <div className="notify-footer d-none">
                  <Link to="">
                    View All Notifications{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="5"
                      viewBox="0 0 8 5"
                      fill="none"
                    >
                      <path
                        d="M4.00004 3.2034L6.97004 0.233398L7.81844 1.0818L4.00004 4.9002L0.181641 1.0818L1.03004 0.233398L4.00004 3.2034Z"
                        fill="#4F46E5"
                      />
                    </svg>
                  </Link>
                </div>
              </Menu>}

              {!location.pathname.startsWith('/admin') && <Button
                className="login-user-profile"
                id="setting-menu"
                aria-controls={open ? "setting-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <div className="user-profile">
                  <img src={UserImage} alt="" />
                </div>
                <span className="login-user-name">{user.name}</span>
                <img
                  className="down-arrow"
                  src={FillDownArrow}
                  alt="FillDownArrow"
                />
              </Button>}
              {!location.pathname.startsWith('/admin') && <Menu
                className="user-setting-dropdown"
                id="setting-menu"
                anchorEl={menu}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "setting-menu",
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <div className="user-setting-head">
                  <div className="user-setting-img">
                    <img src={UserImage} alt="" />
                  </div>
                  <div className="user-setting-content">
                    <div className="user-name">{user.name}</div>
                    <div className="user-email">{user.email}</div>
                  </div>
                </div>
                <MenuItem className={location.pathname === "/dashboard/profile" ? "active" : ""} onClick={() => { handleClose(); navigate("/dashboard/profile") }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4 17.5C4 15.9087 4.63214 14.3826 5.75736 13.2574C6.88258 12.1321 8.4087 11.5 10 11.5C11.5913 11.5 13.1174 12.1321 14.2426 13.2574C15.3679 14.3826 16 15.9087 16 17.5H14.5C14.5 16.3065 14.0259 15.1619 13.182 14.318C12.3381 13.4741 11.1935 13 10 13C8.80653 13 7.66193 13.4741 6.81802 14.318C5.97411 15.1619 5.5 16.3065 5.5 17.5H4ZM10 10.75C7.51375 10.75 5.5 8.73625 5.5 6.25C5.5 3.76375 7.51375 1.75 10 1.75C12.4862 1.75 14.5 3.76375 14.5 6.25C14.5 8.73625 12.4862 10.75 10 10.75ZM10 9.25C11.6575 9.25 13 7.9075 13 6.25C13 4.5925 11.6575 3.25 10 3.25C8.3425 3.25 7 4.5925 7 6.25C7 7.9075 8.3425 9.25 10 9.25Z"
                      fill="#868C98"
                    />
                  </svg>{" "}
                  <span onClick={() => { navigate("/dashboard/profile") }}>My Profile</span>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10.75 16.75V18.25H9.25V16.75H3.25C3.05109 16.75 2.86032 16.671 2.71967 16.5303C2.57902 16.3897 2.5 16.1989 2.5 16V4C2.5 3.80109 2.57902 3.61032 2.71967 3.46967C2.86032 3.32902 3.05109 3.25 3.25 3.25H7.75C8.17569 3.2495 8.59659 3.33982 8.98459 3.51494C9.37259 3.69006 9.71877 3.94594 10 4.2655C10.2812 3.94594 10.6274 3.69006 11.0154 3.51494C11.4034 3.33982 11.8243 3.2495 12.25 3.25H16.75C16.9489 3.25 17.1397 3.32902 17.2803 3.46967C17.421 3.61032 17.5 3.80109 17.5 4V16C17.5 16.1989 17.421 16.3897 17.2803 16.5303C17.1397 16.671 16.9489 16.75 16.75 16.75H10.75ZM16 15.25V4.75H12.25C11.8522 4.75 11.4706 4.90804 11.1893 5.18934C10.908 5.47065 10.75 5.85218 10.75 6.25V15.25H16ZM9.25 15.25V6.25C9.25 5.85218 9.09196 5.47065 8.81066 5.18934C8.52936 4.90804 8.14782 4.75 7.75 4.75H4V15.25H9.25Z"
                      fill="#868C98"
                    />
                  </svg>{" "}
                  <span onClick={() => { if (user.remaining_tokens >= 1 && user.test_given) { navigate("/dashboard/course_list") } else if (user.remaining_tokens >= 1 && user.test_given === false) { navigate('/dashboard') } else { navigate("/price") } }}>My Learning</span>
                </MenuItem>
                {/* <MenuItem onClick={handleClose}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                  >
                    <path
                      d="M8 0.75L15.125 4.875V13.125L8 17.25L0.875 13.125V4.875L8 0.75ZM8 2.48325L2.375 5.73975V12.2603L8 15.5167L13.625 12.2603V5.73975L8 2.48325ZM8 12C7.20435 12 6.44129 11.6839 5.87868 11.1213C5.31607 10.5587 5 9.79565 5 9C5 8.20435 5.31607 7.44129 5.87868 6.87868C6.44129 6.31607 7.20435 6 8 6C8.79565 6 9.55871 6.31607 10.1213 6.87868C10.6839 7.44129 11 8.20435 11 9C11 9.79565 10.6839 10.5587 10.1213 11.1213C9.55871 11.6839 8.79565 12 8 12ZM8 10.5C8.39782 10.5 8.77936 10.342 9.06066 10.0607C9.34196 9.77936 9.5 9.39782 9.5 9C9.5 8.60218 9.34196 8.22064 9.06066 7.93934C8.77936 7.65804 8.39782 7.5 8 7.5C7.60218 7.5 7.22064 7.65804 6.93934 7.93934C6.65804 8.22064 6.5 8.60218 6.5 9C6.5 9.39782 6.65804 9.77936 6.93934 10.0607C7.22064 10.342 7.60218 10.5 8 10.5Z"
                      fill="#868C98"
                    />
                  </svg>{" "}
                  Change Password
                </MenuItem> */}
                <MenuItem className={location.pathname === "/price" ? "active" : ""} onClick={() => {
                  handleClose();
                  if (!user.is_paid && user.remaining_tokens < 1) {
                     navigate('/price')
                     } else {
                    navigate('/dashboard/plan_details')
                  }
                }} >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_2582_68833)">
                      <path
                        d="M7.49992 3.3335C3.81658 3.3335 0.833252 6.31683 0.833252 10.0002C0.833252 13.6835 3.81658 16.6668 7.49992 16.6668C11.1833 16.6668 14.1666 13.6835 14.1666 10.0002C14.1666 6.31683 11.1833 3.3335 7.49992 3.3335ZM7.49992 15.0002C4.74159 15.0002 2.49992 12.7585 2.49992 10.0002C2.49992 7.24183 4.74159 5.00016 7.49992 5.00016C10.2583 5.00016 12.4999 7.24183 12.4999 10.0002C12.4999 12.7585 10.2583 15.0002 7.49992 15.0002ZM9.99992 8.75016H8.33325V12.9168H6.66658V8.75016H4.99992V7.50016H9.99992V8.75016ZM16.8749 3.12516L19.1666 4.16683L16.8749 5.2085L15.8333 7.50016L14.7916 5.2085L12.4999 4.16683L14.7916 3.12516L15.8333 0.833496L16.8749 3.12516ZM16.8749 14.7918L19.1666 15.8335L16.8749 16.8752L15.8333 19.1668L14.7916 16.8752L12.4999 15.8335L14.7916 14.7918L15.8333 12.5002L16.8749 14.7918Z"
                        fill="#868C98"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2582_68833">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>{" "}
                  Upgrade Plan
                </MenuItem>
                <MenuItem className={location.pathname === "/dashboard/help_center" ? "active" : ""} onClick={() => { handleClose(); navigate("/dashboard/help_center") }}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.0245 9.0115C8.72825 10.2479 9.75214 11.2717 10.9885 11.9755L11.6515 11.047C11.7581 10.8977 11.9158 10.7927 12.0946 10.7518C12.2734 10.7108 12.4611 10.7369 12.622 10.825C13.6827 11.4047 14.8542 11.7533 16.0593 11.848C16.2473 11.8629 16.4229 11.9482 16.5509 12.0867C16.6789 12.2253 16.75 12.4071 16.75 12.5958V15.9423C16.75 16.1279 16.6812 16.3071 16.5568 16.4449C16.4324 16.5828 16.2612 16.6696 16.0765 16.6885C15.679 16.7297 15.2785 16.75 14.875 16.75C8.455 16.75 3.25 11.545 3.25 5.125C3.25 4.7215 3.27025 4.321 3.3115 3.9235C3.33044 3.73877 3.41724 3.56764 3.55509 3.44323C3.69295 3.31881 3.87205 3.24996 4.05775 3.25H7.40425C7.59292 3.24998 7.77467 3.32106 7.91326 3.44909C8.05185 3.57711 8.1371 3.75267 8.152 3.94075C8.24667 5.14584 8.59531 6.31726 9.175 7.378C9.2631 7.53892 9.28916 7.72656 9.24825 7.9054C9.20734 8.08424 9.1023 8.24188 8.953 8.3485L8.0245 9.0115V9.0115ZM6.133 8.51875L7.558 7.501C7.15359 6.62807 6.87651 5.70163 6.73525 4.75H4.7575C4.753 4.8745 4.75075 4.99975 4.75075 5.125C4.75 10.717 9.283 15.25 14.875 15.25C15.0002 15.25 15.1255 15.2477 15.25 15.2425V13.2648C14.2984 13.1235 13.3719 12.8464 12.499 12.442L11.4813 13.867C11.0715 13.7078 10.6735 13.5198 10.2903 13.3045L10.2468 13.2797C8.77568 12.4425 7.55746 11.2243 6.72025 9.75325L6.6955 9.70975C6.48018 9.32649 6.29221 8.9285 6.133 8.51875V8.51875Z" fill="#868C98" />
                  </svg>
                  <span onClick={() => navigate("/dashboard/help_center")}>Help Center</span>

                </MenuItem>
                <MenuItem onClick={() => handleSignOut()}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.75 17.5C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V3.25C4 3.05109 4.07902 2.86032 4.21967 2.71967C4.36032 2.57902 4.55109 2.5 4.75 2.5H15.25C15.4489 2.5 15.6397 2.57902 15.7803 2.71967C15.921 2.86032 16 3.05109 16 3.25V5.5H14.5V4H5.5V16H14.5V14.5H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75ZM14.5 13V10.75H9.25V9.25H14.5V7L18.25 10L14.5 13Z"
                      fill="#868C98"
                    />
                  </svg>
                  Sign Out
                </MenuItem>
              </Menu>}
              {/*Start Admin user Profile so, conditionally manage  */}
              {location.pathname.startsWith('/admin') && <Button
                className="login-user-profile admin-user-profile"
                id="profile-menu"
                aria-controls={open1 ? "profile-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClickProfile}
              >
                <div className="user-profile">
                  <img src={UserImage} alt="" />
                  <div className="active-user-badge"></div>
                </div>
                <span className="login-user-name">{user.name}</span>
                <img
                  className="down-arrow"
                  src={FillDownArrow}
                  alt="FillDownArrow"
                />
              </Button>}
              <Menu
                className="user-setting-dropdown admin-profile-dropdown"
                id="profile-menu"
                anchorEl={profile}
                open={open1}
                onClose={handleCloseProfile}
                MenuListProps={{
                  "aria-labelledby": "profile-menu",
                }}
              >
                <div className="user-setting-head">
                  <div className="user-setting-img">
                    <img src={UserImage} alt="" />
                    <div className="active-user-badge"></div>
                  </div>
                  <div className="user-setting-content">
                    <div className="user-name">{user.name}</div>
                    <div className="user-email">{user.email}</div>
                  </div>
                </div>
                <MenuItem onClick={handleClickOpen}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4 17.5C4 15.9087 4.63214 14.3826 5.75736 13.2574C6.88258 12.1321 8.4087 11.5 10 11.5C11.5913 11.5 13.1174 12.1321 14.2426 13.2574C15.3679 14.3826 16 15.9087 16 17.5H14.5C14.5 16.3065 14.0259 15.1619 13.182 14.318C12.3381 13.4741 11.1935 13 10 13C8.80653 13 7.66193 13.4741 6.81802 14.318C5.97411 15.1619 5.5 16.3065 5.5 17.5H4ZM10 10.75C7.51375 10.75 5.5 8.73625 5.5 6.25C5.5 3.76375 7.51375 1.75 10 1.75C12.4862 1.75 14.5 3.76375 14.5 6.25C14.5 8.73625 12.4862 10.75 10 10.75ZM10 9.25C11.6575 9.25 13 7.9075 13 6.25C13 4.5925 11.6575 3.25 10 3.25C8.3425 3.25 7 4.5925 7 6.25C7 7.9075 8.3425 9.25 10 9.25Z"
                      fill="#374151"
                    />
                  </svg>{" "}
                  <span>View Profile</span>
                </MenuItem>

                <MenuItem className="logout-menu-item" onClick={() => {
                  localStorage.removeItem('auth-token')
                  localStorage.removeItem('id')
                  localStorage.removeItem('role')
                  dispatch(logout());
                }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.75 17.5C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V3.25C4 3.05109 4.07902 2.86032 4.21967 2.71967C4.36032 2.57902 4.55109 2.5 4.75 2.5H15.25C15.4489 2.5 15.6397 2.57902 15.7803 2.71967C15.921 2.86032 16 3.05109 16 3.25V5.5H14.5V4H5.5V16H14.5V14.5H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75ZM14.5 13V10.75H9.25V9.25H14.5V7L18.25 10L14.5 13Z"
                      fill="#DF1C41"
                    />
                  </svg>
                  Logout
                </MenuItem>
              </Menu>
              {/*End Admin user Profile so, conditionally manage  */}

              {!location.pathname.startsWith('/admin') && <Button
                className="sidebar-toggle-btn"
                onClick={onHistoryToggle}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.2 3.90002H13.8C15.7096 3.90002 17.5409 4.65859 18.8912 6.00886C20.2414 7.35912 21 9.19047 21 11.1C21 13.0096 20.2414 14.8409 18.8912 16.1912C17.5409 17.5415 15.7096 18.3 13.8 18.3V21.45C9.3 19.65 3 16.95 3 11.1C3 9.19047 3.75857 7.35912 5.10883 6.00886C6.45909 4.65859 8.29044 3.90002 10.2 3.90002V3.90002ZM12 16.5H13.8C14.5091 16.5 15.2113 16.3603 15.8665 16.089C16.5216 15.8176 17.1169 15.4198 17.6184 14.9184C18.1198 14.417 18.5176 13.8217 18.7889 13.1665C19.0603 12.5114 19.2 11.8092 19.2 11.1C19.2 10.3909 19.0603 9.68869 18.7889 9.03353C18.5176 8.37838 18.1198 7.78308 17.6184 7.28165C17.1169 6.78021 16.5216 6.38245 15.8665 6.11107C15.2113 5.8397 14.5091 5.70002 13.8 5.70002H10.2C8.76783 5.70002 7.39432 6.26895 6.38162 7.28165C5.36893 8.29434 4.8 9.66786 4.8 11.1C4.8 14.349 7.0158 16.4694 12 18.732V16.5Z" fill="#525866" />
                  <path d="M8 9.5H17V11H8V9.5ZM8 12.5H13V14H8V12.5Z" fill="#525866" />
                </svg>
              </Button>}
              <Button
                className="sidebar-toggle-btn"
                onClick={onMenuToggle}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M3.90002 4.80078H20.1V6.60078H3.90002V4.80078ZM3.90002 11.1008H20.1V12.9008H3.90002V11.1008ZM3.90002 17.4008H20.1V19.2008H3.90002V17.4008Z" fill="#0A0D14" />
                </svg>
              </Button>
            </div>
          </div>
        </nav>
      </header>

      {/* Admin edit view profile popup  */}
      <EditProfile open={viewprofile} onClose={handleClosePopup} />

      {/* Admin sign out popup  */}
      <SignOutDialog open={signout} onClose={handleCloseSignout} />

    </>
  );
};

export default TopHeader;
